<template>
    <div class="mdl-grid">
        <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--6-col-tablet mdl-cell--4-col-phone mdl-cell--1-offset-tablet" v-for="menu in menus" v-bind:key="menu.menuId">
            <div class="mdl-card mdl-shadow--4dp card">
                <div class="mdl-card__title mdl-card--expand">
                    <h2 class="mdl-card__title-text">
                        <span style="margin: auto">{{ menu.restaurant.name }}</span>&nbsp;&nbsp;&nbsp;
                        <span class="mdl-chip mdl-color--grey-700 mdl-color-text--white mdl-shadow--2dp" v-if="isOpenForOrders(menu)"><span class="mdl-chip__text">Otevřeno pro objednávky</span></span>
                        <span class="mdl-chip mdl-color--amber-700 mdl-color-text--white mdl-shadow--2dp" v-else-if="isOrdered(menu)"><span class="mdl-chip__text">Menu je na cestě</span></span>
                        <span class="mdl-chip mdl-color--green-700 mdl-color-text--white mdl-shadow--2dp" v-else-if="isArrived(menu)"><span class="mdl-chip__text">Jídlo dorazilo!</span></span>
                    </h2>
                </div>
                <ul class='mdl-list'>
                    <li v-for="food in menu.foods" v-bind:key="food.foodId">
                        <food-item v-on:ordered-food="foodSelected(food)"
                                   :order="getFoodOrder()" :selected-options="getSelectedFoodOptions()"
                                   :food="food" :for-user="forUser" :day="day" v-on:snack="snack"
                                   :gold="isPos(1, food.foodCode)"
                                   :silver="isPos(2, food.foodCode)"
                                   :bronze="isPos(3, food.foodCode)"
                                   :disabled="disabled">
                        </food-item>
                    </li>
                </ul>
                <div class="mdl-card__supporting-text">
                    <soup-list :soups="menu.soups" :title="'Polévky'" :selected-soup="getSelectedSoup()" :for-user="forUser"
                               v-on:ordered-food="foodSelected(food)" :day="day" :disabled="disabled"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-unused-vars */
    import FoodItem from "./FoodItem"
    import SoupList from "./SoupList"

    export default {
        name: "MenuList",
        components: {
            SoupList,
            FoodItem
        },
        props: {
            day: String,
            food: Object,
            soup: Object,
            forUser: String,
            menus: Array,
            orderCounts: Array,
            disabled: Boolean
        },
        data: function() {
            return {
            }
        },
        methods: {
            isPos: function (pos, code) {
              if(this.orderCounts === null || this.orderCounts.length < pos)
                return false;
              return this.orderCounts[pos - 1].code === code
            },
            foodSelected: function (food) {
                this.$emit('ordered-food');
            },
            getSelectedFoodOptions: function () {
                if (this.food != null && this.food.foodOptions != null)
                    return this.food.foodOptions;
                else
                    return [];
            },
            getFoodOrder: function () {
                if (this.food != null && this.food.orderedFood != null)
                    return this.food;
                else
                    return null;
            },
            getSelectedSoup: function () {
                if (this.soup != null && this.soup.orderedSoup != null)
                    return this.soup.orderedSoup.soupId;
                else
                    return -1;
            },
            isOpenForOrders: function (menu) {
                return menu.state === "OPEN_FOR_ORDERS";
            },
            isOrdered: function(menu) {
                return menu.state === "CLOSED_FOR_ORDERS";
            },
            isArrived: function(menu) {
                return menu.state === "ARRIVED";
            },
            snack: function (message) {
                this.$emit("snack", message);
            }
        }
    }
</script>

<style scoped>
    .card {
        width: 100%;
        height: 100%;
        margin-bottom: 1.5rem;
    }
</style>